// import any files you need
import spinner from './SpinnerSingleton';

// Register our interceptor function
/** @ignore */
export default function ajaxSpinnerConfig($httpProvider) {
	'ngInject';
	$httpProvider.interceptors.push(ajaxSpinnerInterceptor);
}

// define request and or response interceptors
function ajaxSpinnerInterceptor() {
	'ngInject';
	return {
		request: config => {
			spinner.handleAjaxRequest(config);
			return config;
		},
		response: response => {
			spinner.handleAjaxResponse(response);
			return response;
		},
	};
}
